<script setup>
import { reactive, ref, watch } from 'vue';
import apiEstructuraEscolar from '@/api/estructura_escolar';
import EstructuraEscolar from '../EstructuraEscolar.vue';
import SelectorEstructura from '../SelectorEstructura.vue';
import Path from '../../models/estructura_escolar/Path';

const ESTRUCTURAS_KEY = 'estructuras_escolares';

const props = defineProps({
  condicion: { type: Object, required: true },
  annoLectivoId: { type: Number, default: null },
});

const emits = defineEmits(['aceptar']);

const condicionInterna = reactive(props.condicion);
const selectorEstructura = ref();
const cursos = ref([]);
const cargando = ref(0);

function anadirEstructura() {
  condicionInterna.config = condicionInterna.config || {
    [ESTRUCTURAS_KEY]: [],
  };
  const pathHash = selectorEstructura.value.getPathSeleccionadoEnHash();
  cursos.value.push(new Path(pathHash));
  selectorEstructura.value.limpiarSeleccion();
}

function eliminarEstructura(estructura) {
  const index = cursos.value.indexOf(estructura);
  cursos.value.splice(index, 1);
}

props.condicion.config?.[ESTRUCTURAS_KEY]?.forEach((idsCurso) => {
  cargando.value += 1;
  apiEstructuraEscolar.getDetalle(idsCurso).then((result) => {
    cursos.value.push(new Path(result.data));
  }).finally(() => {
    cargando.value -= 1;
  });
});

watch(cursos, () => {
  condicionInterna.config = condicionInterna.config || {
    [ESTRUCTURAS_KEY]: [],
  };

  condicionInterna.config[ESTRUCTURAS_KEY] = cursos.value.map((path) => (
    path.toParamIds()
  ));
}, { deep: true });

function aceptar() {
  emits('aceptar', condicionInterna);
}
</script>

<template>
  <div>
    <div class="wrapper-anadir">
      <SelectorEstructura
        ref="selectorEstructura"
        :tipos-seleccionables="['anno_lectivo', 'ensennanza', 'curso', 'modalidad']"
        :id-anno-lectivo="annoLectivoId"
      ></SelectorEstructura>
      <button
        type="button"
        class="btn btn-cifra m-l-sm"
        @click="anadirEstructura()"
      >
        <i class="fa fa-plus"></i> {{ $t('Anadir') }}
      </button>
    </div>
    <div class="subtitulo-seccion m-t p-b-xs">
      {{ $t('cursos_permitidos') }}
    </div>
    <div v-if="!cargando" class="p-t-sm">
      <div v-if="!cursos.length">
        Cualquier curso es válido
      </div>
      <div v-for="path in cursos" :key="path" class="m-t-xs">
        <i
          class="fa fa-trash text-danger m-r-sm clickable"
          @click="eliminarEstructura(path)"
        ></i>
        <EstructuraEscolar :path="path"></EstructuraEscolar>
      </div>
    </div>
    <div v-else>
      {{ $t('cargando') }}...
    </div>
    <div class="form-actions m-t">
      <button type="button" class="btn btn-cifra" @click.prevent="aceptar">
        {{ $I18n.t('Aceptar') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/../assets/stylesheets/cifra/vars/main.scss";

.wrapper-anadir {
  display: flex;
  margin-bottom: $margin-md;

  > :first-child {
    flex: 1;
  }
}
</style>
